export default "skymp5-front/9910e73e7cbd8453d7b7a336a98600b3.mp3";